import { type ReactElement } from 'react';
import { useRouter } from 'next/router';
import { type RootLayoutProps } from '@/layout/types';
import { useIsInExternalPlatform } from '@/shared/externalPlatform';
import { Conditional } from '@/shared/googleClassroom';
import { GnbHeaderForExternalPlatform } from './Header/GnbHeaderForExternalPlatform';
import { GnbHeaderForGoogleClassroom } from './Header/GnbHeaderForGoogleClassroom';
import { ProductHeader } from './Header/ProductHeader';
import { PromotionHeader } from './Header/PromotionHeader';
const PROMOTION_HEADER_PATHS = ['/', '/landing', '/pricing', '/biz'];
const isPromotionHeaderPath = (pathname: string) => PROMOTION_HEADER_PATHS.some(path => path === '/' ? pathname === path : pathname.startsWith(path));
const RootLayout = (props: RootLayoutProps) => {
  const isInExternalPlatform = useIsInExternalPlatform();
  const router = useRouter();
  const Header = isPromotionHeaderPath(router.pathname) ? PromotionHeader : ProductHeader;
  return <>
      {isInExternalPlatform ? <GnbHeaderForExternalPlatform /> : <Conditional inGoogleClassroom={<GnbHeaderForGoogleClassroom />}>
          <Header />
        </Conditional>}
      {props.children}
    </>;
};
export function getRootLayout(page: ReactElement) {
  return <RootLayout data-sentry-element="RootLayout" data-sentry-component="getRootLayout" data-sentry-source-file="getRootLayout.tsx">{page}</RootLayout>;
}
export function getLightLayout(page: ReactElement) {
  return <RootLayout data-sentry-element="RootLayout" data-sentry-component="getLightLayout" data-sentry-source-file="getRootLayout.tsx">{page}</RootLayout>;
}